export interface PaginationRequest {
    pageNumber: number,
    pageSize: number,
    sortBy: string,
    sortOrder: boolean,
  }
  